import { Component, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TrackingSolicitudModel, SolicitudModel } from 'src/app/models/credits-application/solicitud.model';
import { AuthService } from 'src/app/services/auth.service';
import { SolicitudesService } from 'src/app/services/solicitudes.service';
import UtilsRest from 'src/utils/UtilsRest';

@Component({
  selector: 'app-firma-contrato-pagare',
  templateUrl: './firma-contrato-pagare.component.html',
  styleUrls: ['./firma-contrato-pagare.component.scss']
})
export class FirmaContratoPagareComponent implements OnInit, OnChanges {

  private token: string = sessionStorage.getItem('token');

  // VALIDACION ROL
  permisoUsuario: boolean;

  // PARAMETROS LOCALES
  tracking: TrackingSolicitudModel[];
  solicitud: SolicitudModel;
  numSolicitud: string;
  contratoPagareFirmado: boolean;
  claveTipoSolicitud: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private solicitudesService: SolicitudesService,
  ) { }

  ngOnInit(): void {
    this.permisoUsuario = this.authService.permisosUsuario();

    this.activatedRoute.queryParams.subscribe(
      params => {
        this.numSolicitud = params['numSolicitud'];
        this.claveTipoSolicitud = params['claveTipoSolicitud'];
        this.buscarSolicitud();
      }
    );
  }

  ngOnChanges(): void {}

  // SERVICIOS EXTERNOS
  buscarSolicitud() {
    this.solicitudesService.obtenerSolicitud(
      this.token, 
      this.numSolicitud, 
      true
    ).subscribe(resp => {

      this.solicitud = resp.resultado;
      this.tracking = this.solicitud.tracking;

    }, (err) => {
      const status = UtilsRest.validaApiError(err, true, this.authService)
      if(status.codigo == 401) {
        this.authService.guardarToken(status.accessToken, status.refreshToken)
        this.buscarSolicitud();
      }
    });
  }

}
